// removed by extract-text-webpack-plugin
module.exports = {"rcSliderTooltipZoomDownIn":"_2jkOYVB6zrCpTNVQ98qR7n","rcSliderTooltipZoomDownOut":"_1Lhy3S0n10qUWURcWEOzBK"};


//////////////////
// WEBPACK FOOTER
// ./~/wix-style-react/dist/es/src/Slider/Slider.scss
// module id = ./node_modules/wix-style-react/dist/es/src/Slider/Slider.scss
// module chunks = 0